<template>
  <div class="feature morningcall notranslate">
    <h1 class="boxTitle mb15 toUppercase">{{locale.morningcall}}</h1>
    <div v-if="isLoading" class="noData">{{ locale.data_loading }}</div>
    <div v-else>
      <!-- morningcall list -->
      <div v-if="active" class="morningcallList">
        <div v-if="auth && auth.result">
          <button v-if="regist" type="button" class="btnAdd" @click="openLayer">{{locale.add_morningcall}}</button>
          <div v-if="list && list.length" class="list">
            <div v-for="(item, index) in list"
              :key="index"
              class="item">
              <button type="button" class="btnDel" @click="toastClearMorningcall(item.id)"></button>
              <div class="time">{{item.time}}</div>
              <div class="date">{{ item.repeat === 'everyday' ? locale.everyday : dateFormat(item.date) }}</div>
            </div>
          </div>
          <div v-else class="noData">{{locale.morningcall_nodata}}</div>
        </div>
        <div v-else class="noData">{{locale.invalid_key}}</div>
      </div>
      <div v-else class="noData">{{locale.alert_not_support}}</div>
      <!-- //morningcall list -->
    </div>
    <!-- morningcall layer -->
    <div v-if="morningcall" class="layer">
      <button type="button" class="btnClose" @click="cancelLayer"></button>
      <div class="inner">
        <h1 class="layerTitle">{{locale.morningcall_settings}}</h1>
        <div class="setMorningcall">
          <div class="repeat">
            <label v-if="setting.once" :class="{checked: morningcall.repeat === 'once'}"><input type="radio" name="morningcall_repeat" value="once" v-model="morningcall.repeat">{{ locale.once }}</label>
            <label v-if="setting.everyday" :class="{checked: morningcall.repeat === 'everyday'}"><input type="radio" name="morningcall_repeat" value="everyday" v-model="morningcall.repeat">{{ locale.everyday }}</label>
          </div>
          <div class="dateTime">
            <div v-if="morningcall.repeat === 'once'" data-custom="calendar" class="fullCalendar small">
              <vc-date-picker
                is-inline
                is-expanded
                v-model="morningcall.date"
                mode="date"
                :value="null"
                :attributes="calendarAttr"
                :min-date="minDate"
                :max-date="maxDate"
                :locale="ln" />
            </div>
            <div :class="{disabled: disabledTime}" class="timePicker">
              <select v-model="morningcall.hh" :disabled="disabledTime" class="timeInput">
                <option v-for="h in 24"
                  :key="h - 1"
                  :value="h - 1">
                  {{ fillPad(h - 1) }}
                </option>
              </select>
              <span class="colon">:</span>
              <select v-model="morningcall.mm" :disabled="disabledTime" class="timeInput">
                <option v-for="m in 60"
                  :key="m - 1"
                  :value="m - 1">
                  {{ fillPad(m - 1) }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="btns">
          <button type="button" class="btn btnWhite" @click="cancelLayer">{{ locale.cancel }}</button>
          <button type="button" class="btn" :disabled="isDisabled" @click="saveMorningcall">{{ locale.save }}</button>
        </div>
      </div>
    </div>
    <!-- //morningcall layer -->
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import moment from 'moment-timezone'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import Toast from '@/components/Util/Toast'

export default {
  name: 'Morningcall',
  props: [
    'locale',
    'isPublic',
    'lang',
    'ln'
  ],
  components: {
    Toast
  },
  computed: {
    guestInfo () {
      return this.$store.getters['guest/getGuestInfo']
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    minDate () {
      return moment().startOf('day').toISOString()
    },
    maxDate () {
      const stayBefore = this.guestInfo && this.guestInfo.stayBefore
      return stayBefore ? moment(stayBefore).endOf('day').toISOString() : moment().add(-1, 'days').toISOString()
    },
    disabledTime () {
      return this.morningcall
        ? this.morningcall.repeat === 'once' && !this.morningcall.date
        : null
    },
    isDisabled () {
      const morningcall = this.morningcall
      const isDate = morningcall ? morningcall.date : null
      const requiredDate = morningcall ? morningcall.repeat === 'once' && !isDate : null
      const date = isDate ? moment(isDate).format('YYYY-MM-DD') : null
      const hh = morningcall ? morningcall.hh : null
      const mm = morningcall ? morningcall.mm : null
      const filteredDate = this.list && date ? this.list.filter(x => x.date === date) : []
      const existItem = filteredDate ? filteredDate.filter(x => {
        return x.date === date && parseInt(x.time.split(':')[0]) === hh && parseInt(x.time.split(':')[1]) === mm
      }).length > 0 : null
      return requiredDate || existItem
    },
    getDate () {
      const date = this.morningcall && this.morningcall.date
      return date && moment(date).format('YYYY-MM-DD')
    },
    getTime () {
      const hh = this.morningcall && this.morningcall.hh
      const mm = this.morningcall && this.morningcall.mm
      return this.morningcall ? `${this.fillPad(hh)}:${this.fillPad(mm)}` : null
    }
  },
  async mounted () {
    const isActive = await this.getFeatureMorningcall()
    this.track()
    if (isActive) {
      this.active = true
      this.$store.commit('loading', true)
      await this.$store.dispatch('authentication/getOtaKey')
      await this.setAuthentication()
      await this.getMorningcall()
      this.$store.commit('loading', false)
    } else {
      alert(this.locale.alert_not_support)
    }
  },
  data () {
    return {
      active: false,
      isLoading: true,
      list: [],
      morningcall: null,
      calendarAttr: [
        {
          bar: 'orange',
          dates: moment().toDate()
        }
      ],
      auth: null,
      toastList: [],
      setting: {
        everyday: true,
        once: true
      },
      regist: false
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'morningcall'
      })
    },
    disabledMm (mm) {
      const isDate = this.morningcall.date
      const date = isDate ? moment(this.morningcall.date).format('YYYY-MM-DD') : null
      const filteredDate = this.list && date ? this.list.filter(x => x.date === date) : []
      const filteredHh = filteredDate ? filteredDate.map(x => parseInt(x.time.split(':')[1])) : null
      return filteredHh.includes(mm)
    },
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'setMorningcall') {
            this.setMorningcall()
          } else if (trigger === 'clearMorningcall') {
            this.clearMorningcall(data.otherData.id)
          } else if (trigger === 'closeToast') {
            this.delToast()
          } else if (trigger === 'cancelSetLayer') {
            this.closeLayer()
            this.delToast()
          }
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    },
    toastClearMorningcall (id) {
      this.addToast('clearMorningcall', 'confirm', this.locale.confirm_delete, { otherData: { id: id } })
    },
    toastSetMorningcall () {
      this.addToast('setMorningcall', 'confirm', this.locale.confirm_save_morningcall)
    },
    async getFeatureMorningcall () {
      function arrToObj (arr) {
        const object = arr.reduce((obj, item) => {
          obj[item.id] = item.active
          return obj
        }, {})
        return object
      }
      return this.$store.dispatch('features/getFeatures').then((res) => {
        const isActive = res && res.morningcall && res.morningcall.active
        if (isActive) {
          this.setting = {
            ...this.setting,
            ...arrToObj(res.morningcall.repeat)
          }
          this.regist = res.morningcall.regist
        }
        return isActive
      })
    },
    setAuthentication () {
      const authentication = this.$store.getters['authentication/getAuthInfo']
      const siteid = authentication && authentication.site
      const spaceid = authentication && authentication.space
      const key = authentication && authentication.k
      const otaValid = this.isPublic || (authentication && authentication.otavalid !== 'false')
      this.auth = {
        siteid: siteid,
        spaceid: spaceid,
        key: key,
        otaValid: otaValid,
        result: siteid && spaceid && key && otaValid
      }
      return true
    },
    dateFormat (date) {
      const dateData = DateTime.fromISO(moment(date).toISOString(), { zone: this.timezone })
      const setting = this.$store.state.common.setting
      const dateFormat = setting.dateFormat[setting.dateformatDefault]
      return dateData.toFormat(dateFormat)
    },
    openLayer () {
      const repeatDefault = this.setting.once
        ? 'once'
        : 'everyday'
      this.morningcall = {
        date: null,
        hh: 6,
        mm: 0,
        repeat: repeatDefault
      }
    },
    closeLayer () {
      this.morningcall = null
    },
    cancelLayer () {
      this.addToast('cancelSetLayer', 'confirm', this.locale.confirm_cancel)
    },
    fillPad (num) {
      return regExp.fillPad(num, 2, 0)
    },
    add () {
      const time = {
        hh: 6,
        mm: 0,
        repeat: 'once'
      }
      this.list.push(time)
    },
    clearMorningcall (id) {
      const authentication = this.auth
      const siteid = authentication && authentication.siteid
      const spaceid = authentication && authentication.spaceid
      const key = authentication && authentication.key
      const otaValid = authentication && authentication.otaValid
      const data = otaValid && {
        siteid: siteid,
        spaceid: spaceid,
        key: key,
        id: id
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/clearMorningcall', data).then((res) => {
        this.addToast('closeToast', 'alert', this.locale.complete_delete)
        this.getMorningcall()
        this.$store.commit('loading', false)
      })
    },
    async getMorningcall () {
      const authentication = this.auth
      const siteid = authentication && authentication.siteid
      const spaceid = authentication && authentication.spaceid
      const key = authentication && authentication.key
      const otaValid = authentication && authentication.otaValid
      const data = otaValid && {
        siteid: siteid,
        spaceid: spaceid,
        key: key
      }
      function setDateTimeObj (setDate, setTime) {
        const dateSplit = setDate && setDate.split('-')
        const timeSplit = setTime && setTime.split(':')
        const year = dateSplit && dateSplit[0]
        const month = dateSplit && dateSplit[1]
        const date = dateSplit && dateSplit[2]
        const hour = timeSplit && timeSplit[0]
        const minute = timeSplit && timeSplit[1]
        return dateSplit
          ? moment().set({ year: year, month: month, date: date, hour: hour, minute: minute })
          : moment().set({ hour: hour, minute: minute })
      }
      if (data) {
        await this.$store.dispatch('guest/getMorningcall', data).then((res) => {
          this.isLoading = false
          if (res) {
            if (res.status && res.status === 403) {
              const status = res.data && res.data.message && res.data.message.status
              if (status === 400) {
                alert(this.locale.alert_permission)
              } else if (status === 401) {
                alert(this.locale.alert_exist_morningcall)
              } else if (status === 402) {
                alert(this.locale.alert_not_support)
              } else if (status === 404) {
                alert(this.locale.message_connection)
              } else if (status === 405) {
                alert(this.locale.alert_registration_failed)
              } else {
                alert(this.locale.ask_front)
              }
              this.active = false
            } else if (res.data) {
              const list = res.data.map(x => {
                return {
                  id: x.morningCallId,
                  date: x.setDate,
                  time: x.setTime,
                  repeat: x.type
                }
              })
              /**
               * 정렬 기준
               * 매일 -> 날짜 -> 시간 순
               */
              this.list = list.sort((a, b) => {
                return a.repeat === 'everyday'
                  ? setDateTimeObj(a.date, a.time).isSameOrBefore(setDateTimeObj(b.date, b.time))
                    ? -1
                    : 0
                  : setDateTimeObj(a.date, a.time).isSameOrBefore(setDateTimeObj(b.date, b.time))
                    ? 0
                    : 1
              })
            } else {
              alert(this.locale.alert_system_error)
            }
            this.$store.commit('loading', false)
          } else {
            alert(this.locale.alert_system_error)
            this.$store.commit('loading', false)
          }
        })
        return true
      }
    },
    setMorningcall () {
      const authentication = this.auth
      const siteid = authentication && authentication.siteid
      const spaceid = authentication && authentication.spaceid
      const key = authentication && authentication.key
      const otaValid = authentication && authentication.otaValid
      const langObj = this.$store.state.common.setting.lang.info
      const subject = function (langObj, val) {
        let obj = {}
        langObj.map(x => {
          obj[x.c] = val || ''
        })
        return obj
      }
      const submitData = {
        title: 'wake-up call',
        info: {
          subject: subject(langObj, 'wake-up call'),
          thumb: ''
        },
        submitAt: moment().toISOString(),
        submitId: 'system_morningcall',
        catCode: 'system_morningcall',
        categoryLabel: 'Morningcall',
        content: [
          {
            label: 'wake-up call',
            type: 'morningcall',
            value: {
              type: this.morningcall.repeat,
              date: this.getDate,
              time: this.getTime
            }
          }
        ]
      }
      const orderData = {
        catCode: 'system_room_service',
        payload: [submitData],
        userInfo: {
          ota: key,
          systemInfo: {}
        }
      }
      const data = otaValid && {
        siteid: siteid,
        spaceid: spaceid,
        key: key,
        data: orderData
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/setMorningcall', data)
        .then((res) => {
          if (res) {
            if (res === 'ok') {
              this.addToast('closeToast', 'alert', this.locale.alert_save_morningcall_complete)
              this.closeLayer()
              this.getMorningcall()
              this.$store.commit('loading', false)
            } else if (res.status === 403 && res.data) {
              const status = res.data && res.data.message && res.data.message.status
              if (status === 400) {
                alert(this.locale.alert_permission)
              } else if (status === 401) {
                alert(this.locale.alert_exist_morningcall)
              } else if (status === 402) {
                alert(this.locale.alert_not_support)
              } else if (status === 404) {
                alert(this.locale.message_connection)
              } else if (status === 405) {
                alert(this.locale.alert_registration_failed)
              } else {
                alert(this.locale.ask_front)
              }
              this.$store.commit('loading', false)
            }
          } else {
            alert(this.locale.alert_system_error)
            this.$store.commit('loading', false)
          }
          this.$store.commit('loading', false)
        })
    },
    validateSave () {
      let result = false
      if (this.morningcall.repeat === 'once' && !this.morningcall.date) {
        this.addToast('closeToast', 'alert', this.locale.alert_set_date)
      } else {
        result = true
      }
      return result
    },
    async saveMorningcall () {
      if (this.validateSave()) {
        this.toastSetMorningcall()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.morningcall {
  min-height: 100vh;
}
.btnAdd {
  width: 100%;
  margin-bottom: 15px;
  padding: 15px 10px;
  color: $color-lgrey;
  border-radius: 8px;
  border: 1px solid $color-lgrey2;
}
.btnSave {
  border-radius: 8px;
}
.morningcallList {
  .list {
    border: 1px solid $color-lgrey2;
    border-radius: 8px;
  }
  .item {
    display: flex;
    align-items: center;
    position: relative;
    padding: 30px;
    font-family: 'Pretendard', 'Noto Sans', sans-serif;
    line-height: 1;
    & + .item {
      border-top: 1px solid $color-lgrey2;
    }
  }
  .date {
    margin-left: 45px;
    color: $color-grey;
  }
  .time {
    font-size: 32px;
    letter-spacing: 0.05em;
  }
}
.btnDel {
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
  background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 12px no-repeat;
  opacity: 0.3;

}
.noData {
  display: block;
  padding: 40px 15px 60px;
  text-align: center;
  color: $color-grey;
}
.timePicker {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  border-radius: 8px;
  border: 1px solid $color-lgrey2;
  &.disabled {
    color: $color-lgrey;
    background-color: $bg-default;
    .timeInput {
      color: inherit;
    }
  }
}
.timeInput {
  padding: 10px 15px;
  font-size: 30px;
  letter-spacing: 0.2em;
  border: none;
  -webkit-appearance: none;
  background: none;
  option {
    font-size: 16px;
  }
}
.setMorningcall {
  font-family: 'Pretendard', 'Noto Sans', sans-serif;
}
.colon {
  margin: 0 4px;
  font-size: 30px;
}
.repeat {
  display: flex;
  overflow: hidden;
  margin-bottom: 15px;
  border-radius: 8px;
  label {
    flex: 1;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
    color: $color-grey;
    border: 1px solid $color-lgrey2;
    background-color: $bg-default;
    cursor: pointer;
    + label {
      border-left: none;
    }
    &.checked {
      color: $color-white;
      border-color: $color-primary;
      background-color: $color-primary;
    }
  }
}
@media screen and (min-width: 480px) {
  .dateTime {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .fullCalendar {
    flex: 1.8;
  }
  .timePicker {
    flex: 1;
    margin-top: 0;
    margin-left: 10px;
  }
}
</style>
